import React, {Component} from 'react'
import apigClientFactory from 'aws-api-gateway-client'
import aws from '../aws-config'

import VideoJS from './VideoJS'
import Activity from './Activity'
import {ending} from '../config'

export default class Ending extends Component {
  state = {
    vid: true,
    activity: false
  }

  sendCompletionEmail = () => {

    const apigClient = apigClientFactory.newClient({
      invokeUrl: aws.apiGateway.URL,
      region: aws.apiGateway.REGION,
      retryCondition: (err) => {
        return err.response.status === 500
      }
    })

    let headers = {'Access-Control-Allow-Origin': '*'}
    let pathTemplate = '/icare/email'
    let method = 'POST'
    let params = {
      queryParams: {
        email: this.props.user.email,

      }
    }

    apigClient.invokeApi(headers, pathTemplate, method, params)
      .then(result => {
        return
      })
      .catch(error => {
        console.log('err: ', error)
      })

  }

  onEnded = () => {
    if (this.state.vid) {
      this.setState({vid: false, activity: true})
    } else {
      this.setState({vid: false, activity: false, fin: true})
    }
  }

  render() {
    return (
      <div>
        {this.state.vid && (
          <div className="player">
            <div className="video-outer">
              <div className="video-inner">
                )
                <VideoJS
                  onEnded={() => this.onEnded()}
                  textChanged={this.props.textChanged}
                  autoplay={true}
                  controls={true}
                  fluid={true}
                  sources={[{src: ending.src, type: 'video/mp4'}]}
                  captions={ending.captions}
                  captionOn={this.props.captionOn}
                  tracks={[
                    {
                      src: ending.captions,
                      controlBar: {volumePanel: {inline: false}},
                      kind: 'captions',
                      label: 'English',
                      mode: 'disabled',
                      tech: 'Html5',
                      default: this.props.captionOn
                    }
                  ]}
                />
              </div>
            </div>
          </div>
        )
        }
        {this.state.activity && (
          <Activity
            index={0}
            onEnd={() => this.onEnded()}
            onClickPlaylistItem={0}
            playlist={''}
            module={ending.activity}
          />
        )
        }

        { this.state.fin && <p style={{ color: 'green' }}>{"Thank you for caring and participating in this training program!"}</p> }
        { this.state.fin && this.sendCompletionEmail() }

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Ending.js